import { render } from "./ValidatedMessage.vue?vue&type=template&id=77879c1e&scoped=true&ts=true&lang=pug"
import script from "./ValidatedMessage.vue?vue&type=script&lang=ts"
export * from "./ValidatedMessage.vue?vue&type=script&lang=ts"

import "./ValidatedMessage.vue?vue&type=style&index=0&id=77879c1e&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77879c1e"]])

export default __exports__